module.exports = __webpack_public_path__ + "static/media/ckf_logo.fe4e82b4.svg";